import { IDataForEventsIsRejected } from '../../../actions/bookingCalendar/event/requestDataForEvents'
import { IEventsStore } from '../../events'

export default function(
  state: IEventsStore,
  action: IDataForEventsIsRejected,
): IEventsStore {
  return {
    ...state,
    request: {
      ...state.request,
      events: {
        ...state.request.events,
        errMessage: action.errMessage,
        isLoading: false,
      },
    },
  }
}
